import { getIsQuizOpen } from '@bridebook/web/lib/quiz/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';

const VideoQuizLazy = lazyComponent(() => import('./video-quiz'));

const VideoQuiz = () => {
  const isQuizOpen = useSelector(getIsQuizOpen('videographyStyle'));

  if (!isQuizOpen) {
    return null;
  }

  return <VideoQuizLazy />;
};

export default VideoQuiz;
